
export class TipoDepartamento {
    tipodepartamentoid: number = 0;
    nombre: string = "";
    asociarnivel: boolean = false;
    activo: boolean = true;

    constructor(init?: Partial<TipoDepartamento>) {
        Object.assign(this, init);
    }
}
